import * as z from "zod";

/** One merchant-safe KYC issue as Gale reports it. Never developer text. */
export const hsaGaleOnboardingIssueSchema = z.object({
  code: z.string(),
  message: z.string(),
  action: z.string().nullable(),
  occurredAt: z.string().nullable(),
});
export type HsaGaleOnboardingIssue = z.infer<
  typeof hsaGaleOnboardingIssueSchema
>;

/**
 * Kind-specific facts stored on a Gale onboarding event. Every member is
 * optional so a row written by a newer watcher still parses for an older
 * reader. `issues` is for the KYC kinds, `productCount` and
 * `eligibilityPushedAt` for the catalog kinds; the other kinds carry nothing.
 */
export const hsaGaleOnboardingEventDetailsSchema = z.object({
  issues: z.array(hsaGaleOnboardingIssueSchema).optional(),
  productCount: z.number().int().optional(),
  eligibilityPushedAt: z.string().optional(),
});
export type HsaGaleOnboardingEventDetails = z.infer<
  typeof hsaGaleOnboardingEventDetailsSchema
>;

/** A catalog event's variant count as both the admin card and Slack show it. */
export function formatGaleCatalogVariantCount(count: number): string {
  return `${count} variant${count === 1 ? "" : "s"}`;
}
